// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lazy-load-image-background.blur {\n  filter: blur(15px);\n}\n\n.lazy-load-image-background.blur.lazy-load-image-loaded {\n  filter: blur(0);\n  transition: filter .3s;\n}\n\n.lazy-load-image-background.blur > img {\n  opacity: 0;\n}\n\n.lazy-load-image-background.blur.lazy-load-image-loaded > img {\n  opacity: 1;\n  transition: opacity .3s;\n}\n", ""]);
// Exports
module.exports = exports;
